export default __webpack_public_path__ + "static/media/autolike-status@3x.e8c455aa.png";